import { render, staticRenderFns } from "./staticsCard.vue?vue&type=template&id=43216064&scoped=true"
import script from "./staticsCard.vue?vue&type=script&lang=js"
export * from "./staticsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43216064",
  null
  
)

export default component.exports